(function () {
  if (window.__birthdayGiftCleanupInit) return;
  window.__birthdayGiftCleanupInit = true;

  var removalInFlight = false;
  var cartIsClean = false;

  function getConfig() {
    return window.BirthdayGiftConfig || null;
  }

  function isCheckoutPath() {
    var p = window.location.pathname || '';
    return p.startsWith('/checkout') || p.startsWith('/checkouts');
  }

  function isCartPath() {
    var p = window.location.pathname || '';
    return /(^|\/)cart(\/|$)/.test(p);
  }

  async function removeGiftIfNotCheckout() {
    if (isCheckoutPath()) return;
    if (!isCartPath() && cartIsClean) return;

    var config = getConfig();
    if (!config) return;

    var giftVariantId = Number(config.giftVariantId);
    if (!giftVariantId) return;

    if (removalInFlight) return;
    removalInFlight = true;

    try {
      var cartRes = await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      });

      if (!cartRes.ok) return;

      var cart = await cartRes.json();

      var hasGift = (cart.items || []).some(function (item) {
        return Number(item.variant_id) === giftVariantId;
      });

      if (!hasGift) {
        cartIsClean = true;
        return;
      }

      /* Check if cart still qualifies — if it does, keep the gift */
      var subtotal = 0;
      (cart.items || []).forEach(function (item) {
        for (var i = 0; i < config.excludeProductIds.length; i++) {
          if (Number(item.product_id) === Number(config.excludeProductIds[i])) return;
        }
        subtotal += Number(item.final_line_price || 0);
      });

      if (subtotal >= config.thresholdCents) {
        /* Cart still qualifies, keep the gift */
        cartIsClean = true;
        return;
      }

      /* Cart doesn't qualify, remove the gift */
      cartIsClean = false;

      var updates = {};
      updates[giftVariantId] = 0;

      var updateRes = await fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ updates: updates })
      });

      if (!updateRes.ok) return;

      window.location.reload();
    } catch (e) {
      console.error('[Birthday Gift cleanup] error:', e);
    } finally {
      removalInFlight = false;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeGiftIfNotCheckout, { once: true });
  } else {
    removeGiftIfNotCheckout();
  }

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    cartIsClean = false;
    removalInFlight = false;
    removeGiftIfNotCheckout();
  });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      removeGiftIfNotCheckout();
    }
  });
})();
